<template>
  <div class="wrapper">
    <div class="doc_left">
      <div class="info">
        <div>创建时间：{{ baseInfo.uploadtime }}</div>
        <div>浏览次数：{{ baseInfo.browsecount }}</div>
        <div>下载次数：{{ baseInfo.downloadcount }}</div>
      </div>
      <div class="doc" style="position: relative">
        <iframe
          ref="iframe"
          id="iframe"
          title="fujian"
          :src="baseInfo.previewurl"
          style="border: 0; min-height: 600px"
          width="100%"
          height="100%"
        />
      </div>
    </div>
    <div class="doc_right">
      <div class="label">{{ baseInfo.coursename }}</div>
      <div>
        <el-button
          type="primary"
          style="width: 100%; margin: 20px 0"
          icon="el-icon-download"
          @click="downloadFile"
          >下载源文件({{ baseInfo.file_size }}M)</el-button
        >
      </div>
      <div class="label">课题相关文档</div>
      <div class="list">
        <div
          v-for="(item, index) in fileList"
          :key="index"
          @click="openFile(item)"
        >
          {{ item.fileName }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["mxParams"],
  data() {
    return {
      baseInfo: {},
      fileList: [],
    };
  },
  created() {
    this.baseInfo = this.mxParams;
    this.openPreview();
    this.getList();
    this.$nextTick(() => {
      let iframe = document.querySelector("#iframe");
      try {
      } catch {
        iframe.contentWindow.document.addEventListener(
          "oncontextmenu",
          function () {
            alert(1);
            ("event.returnValue=false");
          }
        );
        iframe.contentWindow.document.addEventListener(
          "onselectstart",
          function () {
            alert(1);
            ("event.returnValue=false");
          }
        );
        iframe.contentWindow.document.body.setAttribute(
          "oncontextmenu",
          "return false"
        );
        iframe.contentWindow.document.body.setAttribute(
          "onselectstart",
          "return false"
        );
        iframe.contentWindow.document.body.setAttribute("id", "qqq");
      }
    });
  },
  methods: {
    openPreview() {
      const row = this.mxParams;
      this.$store
        .dispatch("course/addBrowseCountAction", {
          fileId: row.file_id,
        })
        .then((res) => {
          if (res.code == 0) {
            this.$emit("getParentData");
            this.baseInfo = this.mxParams;
            this.baseInfo.browsecount++;
          }
        });
    },
    openFile(row) {
      this.$store.dispatch("course/addBrowseCountAction", {
        fileId: row.fileId,
      });
      const url = row.previewUrl;
      window.open(url);
    },
    downloadFile() {
      const row = this.mxParams;
      this.$store
        .dispatch("course/addDownloadCountAction", {
          fileId: row.file_id,
        })
        .then((res) => {
          if (res.code == 0) {
            this.baseInfo.downloadcount++;
          }
        });
      const filePath = row.serverpath;
      const fileName = row.file_name;

      const url =
        window.g.apiUrl +
        "system/downloadFile?fileName=" +
        fileName +
        "&filePath=" +
        filePath;
      // 组装a标签
      const elink = document.createElement("a");
      // 设置下载文件名
      elink.download = fileName;
      elink.style.display = "none";
      elink.href = url;
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
    },
    getList() {
      const params = {
        page: 1,
        pageSize: 50,
        step: "",
        fileType: "",
        group: "",
        courseLeader: "",
        fileName: "",
        courseId: this.mxParams.courseid,
      };

      this.$store
        .dispatch("course/fetchCourseFileListAction", {
          params,
        })
        .then((res) => {
          if (res.code == 0) {
            this.fileList = res.data;
          }
        });
    },
  },
};
</script>
<style scoped lang="less" >
.wrapper {
  display: flex;
  .doc_left {
    width: 70%;
    padding-right: 15px;
    height: 100%;
    .info {
      display: flex;
      margin-bottom: 15px;
      > div {
        padding: 0 15px;
        border-left: 1px solid #999;
      }
      > div:nth-of-type(1) {
        border-left: 0;
      }
    }
    .doc {
      min-height: 500px;
    }
  }
  .doc_right {
    width: 30%;
    .label {
      line-height: 24px;
      font-size: 18px;
      color: #303133;
    }
    .list {
      div {
        line-height: 36px;
        font-size: 14px;
        cursor: pointer;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        border-bottom: 1px dashed #999;
      }
    }
  }
}
</style>